export * from './cookies-consent.component';
